import React, { useEffect, useRef, useState } from 'react'
import { KTIcon } from '../../../_metronic/helpers';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import '../../../common/rsuite-datepicker.css';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import Loader from '../../../common/Loader';
import { format } from 'date-fns';
import { getValueFromResource } from '../../../common/timeLiveFunction';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import {
    getExpenseEntryArchiveForDatatableAsync, resetSelectedRecordObjectInState, deleteAccountEmployeeExpenseEntryAsync,
    setDateRangeValue, setOptionApprovedValue, setOptionClientNameValue, setOptionEmployeeNameValue, setOptionProjectTaskValue, setOptionProjectValue, setIncludeDateRangeValue

} from "./ExpenseEntryArchiveSlice";
import DatePickerRanges from '../../../common/DatePickerRanges';
interface DropdownItem {
    value: number;
    label: string;
}

const ExpenseEntryArchiveFilter = (props: any) => {
    const { t } = props;
    const dispatch = useAppDispatch();
    const { maxMenuHeight,sessionAccountEmployeeId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const { isLoading } = useAppSelector((state) => state.expenseEntryArchive);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [EmployeeNameArray, setEmployeeNameArray] = useState<any | ''>([]);
    const [selectedEmployeeNameOptionDropDown, setSelectedEmployeeNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [hasMoreTL, setHasMoreTL] = useState(true);
    const [dataEmployees, setDataEmployees] = useState<DropdownItem[]>([]);

    const [ApprovedArray, setApprovedArray] = useState<any | ''>([]);
    const [selectedApprovedOptionDropDown, setSelectedApprovedOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'Both' });
    const [includeDateRange, setIncludeDateRange] = useState<boolean>(false);

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [displayedRange, setDisplayedRange] = useState(t('Please Select Date Range'));
    const IsShowEmployeeNameWithCode = true
    const [page, setPage] = useState(1);
    const [searchEmp, setSearchEmp] = useState<string>('');

    useEffect(() => {
        let ApprovedArray = [
            { value: '-1', label: 'Both' },
            { value: '1', label: 'Approved' },
            { value: '0', label: 'Not Approved' },
        ]
        setApprovedArray(ApprovedArray);
    }, [])

    useEffect(() => {
        getEmployeeNameAsync();
    }, [])
    const getEmployeeNameAsync = async () => {
        const response: any = await fetchAPI(`api/V2/Employees/CurrentActiveNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${1}&search=${""}`, "GET", "", true);
        const json = await response.json();
        const transformedData = json.items.map((item: any) => ({
            value: item.id,
            label: item.text,
        }));       
        setSelectedEmployeeNameOptionDropDown({ value: '0', label: 'All' });
    }


    const fetchData = async (pageNum: any, searchEmp: string) => {
        setLoading(true);
        try {
            const searchParam = searchEmp ? `&search=${searchEmp}` : "";
            const response: any = await fetchAPI(
                `api/V2/Employees/CurrentActiveNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${pageNum}${searchParam}`,
                "GET",
                "",
                true
            );
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            if (pageNum === 1) {
                transformedData.unshift({ value: '0', label: 'All' });
                setSelectedEmployeeNameOptionDropDown({ value: '0', label: 'All' });
            }    
            const newItemsTL = transformedData.filter(
                (item: any) => !dataEmployees.some((existingItem: any) => existingItem.value === item.value)
            );
            setDataEmployees((prevData) => [...prevData, ...newItemsTL]);
            setHasMoreTL(newItemsTL.length > 0);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchData(page, searchEmp);
    }, [page, searchEmp]);



    const handleDateRangeChange = (value: any) => {
        // setStartDate(value[0]);
        // setEndDate(value[1]);
        // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }))
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
        setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    };

    const handleEmployeeNameChange = (data: any) => {
        const { value, label } = data;
        setSelectedEmployeeNameOptionDropDown({ value: value, label: label });
        dispatch(setOptionEmployeeNameValue({ value: value, label: label }));

    };

    const handleChange = (e: any) => {
        setIncludeDateRange(e.target.checked);
        dispatch(setIncludeDateRangeValue(e.target.checked));
    };

    const handleApprovedChange = (data: any) => {
        const { value, label } = data;
        setSelectedApprovedOptionDropDown({ value: value, label: label });
        dispatch(setOptionApprovedValue({ value: value, label: label }));

    };

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        dispatch(resetSelectedRecordObjectInState());
        let SearchParamsValues = `${selectedEmployeeNameOptionDropDown.value},${selectedApprovedOptionDropDown.value},${includeDateRange},${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)}`;
        dispatch(getExpenseEntryArchiveForDatatableAsync(SearchParamsValues));
    };
    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setSelectedEmployeeNameOptionDropDown({ value: '0', label: 'All' });
        setSelectedApprovedOptionDropDown({ value: '-1', label: 'Both' });
        setIncludeDateRange(false);
        dispatch(setIncludeDateRangeValue(false));
        dispatch(resetSelectedRecordObjectInState());
        let SearchParamsValues = `${0},${selectedApprovedOptionDropDown.value},${false},${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)}`;
        dispatch(getExpenseEntryArchiveForDatatableAsync(SearchParamsValues));
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }

    };

    const handleInputEmp = (inputValue: string) => {
        setSearchEmp(inputValue);
    }

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreTL && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const customMenuList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }


    return (
        <>
            {isLoading && <Loader />}
            <div className='card-body'>
                <div className='row' >
                    <div className='col-md-12'>
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges() }
                                value={[startDate, endDate]}
                                // placeholder={t('Please Select Date Range')}
                                placeholder={displayedRange}
                                character={' - '}
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>

                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                            </label>
                        <div>
                            {/* <Select
                                value={selectedEmployeeNameOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleEmployeeNameChange}
                                options={EmployeeNameArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            /> */}
                            <Select
                                                        value={selectedEmployeeNameOptionDropDown}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="employeeArray"
                                                        onChange={handleEmployeeNameChange}
                                                        options={dataEmployees}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        // onInputChange={handleInputEmp}
                                                        components={{ MenuList: customMenuList }}
                                                    />
                        </div>
                    </div>
                </div>

                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Approved')} */}
                            {getValueFromResource('Approved',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedApprovedOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="ApprovedList"
                                onChange={handleApprovedChange}
                                options={ApprovedArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>

                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Include Date Range')} */}
                            {getValueFromResource('Include Date Range',dispatch, t)}
                            </label>
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input className="form-check-input h-20px w-30px mt-2"
                                type="checkbox"
                                checked={includeDateRange}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {/* {t('Apply Filter')} */}
                            {getValueFromResource('Apply Filter',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            data-kt-element='send'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters',dispatch, t)}
                        </button>

                        <button
                            type="button"
                            data-kt-element='send'
                            className="btn btn-primary btn-sm fs-7 "
                            onClick={handleApplyFilterOnClickEvent}
                        >
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters',dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>
        </>

    )

}


export default ExpenseEntryArchiveFilter